// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { THideRatingModel, IMappers, THideRatingResponse, THideRatingResponseData200 } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createHideRatingModel(): THideRatingModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'cian-chat-bot',
    pathApi: '/v1/hide-rating/',
    response: {
      '200': {},
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IHideRatingOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchHideRating<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IHideRatingOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<THideRatingResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createHideRatingModel(),
    config,
  )) as FetchResponse<THideRatingResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as THideRatingResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<THideRatingResponse>;
}
